import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const StyledHeader = styled.header`
  grid-area: 1/1/ 2 / end;
  display: grid;
  grid-template-columns: minmax(min-content, 150px) repeat(8, 1fr) minmax(
      min-content,
      120px
    );
  grid-template-rows: minmax(min-content, 10vh);
  align-items: center;
  width: 95vw;
  margin: 0 auto;
  padding: 2rem;
  max-height: 13vh;
  overflow: visible;
  position: relative;
  z-index: 7;
  @media (min-width: 500px) {
    width: 85vw;
  }
  @media (min-width: 750px) {
    padding: 0;
    width: 100vw;
    grid-template-rows: minmax(fit-content, 15vh);
    grid-template-columns: minmax(min-content, 50vw) minmax(min-content, 50vw);
    max-height: 20vh;
  }
  @media (min-width: 1250px) {
    max-height: 18.5vh;
  }
  > a {
    grid-area: 1/1/2/2;
    @media (min-width: 750px) {
      margin: 0 auto;
      grid-area: 1/1 / -1/2;
      width: fit-content;
      img {
        object-fit: contain;
        width: 80%;
        max-width: 200px;
        height: auto;
      }
    }
  }

  > button {
    grid-area: 1/10/2/11;
    justify-self: flex-end;
    margin-right: 7.8%;
    @media (min-width: 750px) {
      display: none;
    }
  }
  > ul {
    grid-area: 2/10/3/11;
    justify-self: flex-end;
    align-self: center;
    @media (min-width: 750px) {
      grid-area: 1/1/-1/2;
      margin-right: 5%;
      align-self: flex-start;
    }
    @media (min-width: 1250px) {
      transform: rotate(-90deg);
      margin-right: 8%;
    }
  }
`;
export const StyledButton = styled.button`
  background-color: transparent;
  border: none;
  outline: 1px solid transparent;
  width: min-content;
  :hover,
  :active {
    transform: scale(.95);
    outline: ${({ theme }) => `1px dotted ${theme.colors.textPrimary}`};
  }
  :focus,
  :focus-visible,
  :focus-within {
    outline: ${({ theme }) => `1px dotted ${theme.colors.textPrimary}`};
  }
`;
export const StyledImg = styled.img`
  width: auto;
  height: auto;
`;
export const StyledLink = styled(Link)`
  cursor: pointer;
  text-decoration: none;
  color: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: 1px solid transparent;
  transition: ${({ theme }) => `${theme.transition.default}`};
  :focus,
  :focus-visible,
  :focus-within {
    outline: ${({ theme }) => `1px dotted ${theme.colors.textPrimary}`};
  }
  :hover {
    color: ${({ theme }) => theme.colors.defaultGrey};
  }
`;
export const ThemeChangers = styled.ul`
  background-color: #0000001b;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.5rem 0.8rem;
  width: min-content;
  opacity: ${(props) => (props.transparent ? ".3" : "1")};
  border-radius: 20px;
  list-style-type: none;
  transition: ${({ theme }) => `${theme.transition.default}`}
    }
  :focus,
  :focus-visible,
  :focus-within {
    outline: 2px solid #5c5c5c;
  }
`;
export const ThemeChanger = styled.li`
    width: 30px;
    height: 30px;
    background: ${(props) => props.mainColor};
    border: ${(props) =>
      props.active ? "2px dotted #919794" : "2px solid #5C5C5C"};
    border-radius: 50%;
    margin: 8% auto;
      @media (min-width: 750px) {
        width: 25px;
        height: 25px;
      }
     :hover{
        border: ${({ theme }) => `2px dotted ${theme.colors.textPrimary}`};
      }
    button {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      transition: ${({ theme }) => `${theme.transition.default}`};
      :hover{
        border: 1px solid transparent;
      }
      :focus,
      :focus-visible,
      :focus-within {
        outline-offset: 3px;
      }
    }
  }
`;
export const StyledMobileNav = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: ${({ theme }) => theme.colors.defaultOverlay};
  z-index: 8;
  visibility: ${(props) => (props.showNav ? "visible" : "hidden")};
  opacity: ${(props) => (props.showNav ? 1 : 0)};
  transition: all 1s ease;
  transition-delay: 0s;
  @media (min-width: 750px) {
    visibility: visible;
    opacity: 1;
    position: unset;
    width: 100%;
    margin: 0 auto;
    height: fit-content;
    background: transparent;
    grid-area: 1/2 / -1/-1;
    padding: 0 4rem 0 0;
  }
  .nav-open-first {
    position: fixed;
    top: 0;
    left: 0;
    width: 70vw;
    height: 100vh;
    background-color: ${({ theme }) => theme.colors.defaultGrey};
    z-index: 10;
    transform: translateX(${(props) => (props.showNav ? "0" : "-500%")});
    transition-delay: 0s;
    transition: all 1s ease;
    @media (min-width: 500px) {
      width: 60vw;
      max-width: 330px;
    }
    @media (min-width: 750px) {
      display: none;
    }
  }
  nav {
    position: fixed;
    top: 0;
    left: 0;
    width: 65vw;
    height: 100vh;
    background-color: ${({ theme }) => theme.colors.primaryColor};
    z-index: 10;
    transform: translateX(${(props) => (props.showNav ? "0" : "-500%")});
    transition-delay: 1.5s;
    transition: all 1s ease;
    display: grid;
    grid-template-rows: minmax(min-content, 10vh) 1fr;
    grid-template-columns: 1fr;
    @media (min-width: 500px) {
      width: 55vw;
      max-width: 300px;
    }
    @media (min-width: 750px) {
      display: flex;
      transform: translateX(0);
      position: unset;
      width: 100%;
      height: 100%;
      max-width: unset;
      background-color: transparent;
    }
    div:nth-of-type(1) {
      grid-area: 1/1/2 / end;
      justify-self: flex-end;
      align-self: center;
      padding: 2rem;
      @media (min-width: 750px) {
        display: none;
      }
      button {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }
    div:nth-of-type(2) {
      grid-area: 2/1 / -1/-1;
      width: 100%;
      height: 100%;
      margin: 0 auto;
    }
  }
`;
export const StyledMobileNavList = styled.ul`
  list-style-type: none;
  font-size: 1.4rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-transform: capitalize;
  @media (min-width: 750px) {
  justify-content: center;
    flex-direction: row;
    font-size: 1.2rem;
  }
  > li{
    :not(last-child) {
    margin: 0 0 12%;
    width: max-content;
    }
    @media (min-width: 750px) {
    :not(last-child) {
    margin: 0 0;
    width: max-content;
    }
        margin: 0;
        padding: 0 3%;  
        display: flex;
        justify-content: center;
        align-items: center;  
        width: fit-content;
          margin: 0;
        :nth-of-type(even){
          border-right: 1px solid ${({ theme }) => theme.colors.textPrimary};
          border-left: 1px solid ${({ theme }) =>
            theme.colors.textPrimary};      
        }
    }
`;
export const StyledMobileNavListSecond = styled(StyledMobileNavList)`
  margin: -7% 0 0;
  @media (min-width: 750px) {
   display: none;
  }
`;